import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentWorkOfferLookupComponent } from './payment-work-offer-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PaymentWorkOfferLookupComponent],
  exports: [PaymentWorkOfferLookupComponent],
  providers: []
})
export class PaymentWorkOfferLookupModule { }
